const STATUS_CONFIG = {
    RUPTURA: {
        label: 'Ruptura',
        bg: '#fff1f0',
        color: '#f5222d',
    },

    CRITICO: {
        label: 'Crítico',
        bg: '#fff7e6',
        color: '#fa8c16',
    },

    ALTO: {
        label: 'Alto',
        bg: '#e6f4ff',
        color: '#1677ff',
    },

    BAIXO: {
        label: 'Baixo',
        bg: '#fffbe6',
        color: '#d4b106',
    },

    MODERADO: {
        label: 'Moderado',
        bg: '#f6ffed',
        color: '#52c41a',
    },

    NORMAL: {
        label: 'Normal',
        bg: '#e6f4ff',
        color: '#1677ff',
    },

    SEM_VENDA: {
        label: 'Sem venda',
        bg: '#f9f0ff',
        color: '#722ed1',
    },

    OBSOLETO: {
        label: 'Obsoleto',
        bg: '#434343',
        color: '#f5f5f5',
    },

    EXCESSO: {
        label: 'Excesso',
        bg: '#f5f5f5',
        color: '#8c8c8c',
    },

    NEGATIVO: {
        label: 'Negativo',
        bg: '#fff1f0',
        color: '#a8071a',
    },
};

export function getStockStatus(criticidade) {
    return STATUS_CONFIG[criticidade] || {
        label: criticidade || '—',
        bg: '#f5f5f5',
        color: '#595959',
    };
}
